import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import * as yaml from 'js-yaml';
import { BosEvent } from '@model';
import { EventService } from '@service';

@Component({
  selector: 'bmd-risk-profiles-modal',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./event-modal.component.scss'],
  templateUrl: './event-modal.component.html',
})
export class EventModalComponent implements OnInit {
  @Input() bosShallowEvent: BosEvent;
  bosEvent: BosEvent;
  payload: {};
  loadingEvent: boolean;
  constructor(
    public dialogRef: MatDialogRef<EventModalComponent>,
    private eventService: EventService,
    @Inject(MAT_DIALOG_DATA) public data: MatDialogConfig<any>,
  ) {}

  ngOnInit() {
    this.loadingEvent = true;
    this.loadEvent();
  }

  loadEvent = () => {
    this.eventService.getRecentEvent(this.bosShallowEvent.messageId).subscribe(event => {
      // TODO: manage error if event not in cache or invalid bosEventId
      this.bosEvent = event;
      this.loadingEvent = false;

      // For errors, payload is a string, not JSON
      if (this.bosEvent.name == 'texmark_error.discovered') {
        this.payload = '<No payload>';
      } else {
        const payloadObj = JSON.parse(this.bosEvent.payload);
        if (payloadObj) {
          this.payload = yaml.dump(payloadObj, { quotingType: '"' });
          if (EventModalComponent.isBidSubmittedEvent(this.bosEvent.name)) {
            // Special case for bid submitted: Show bid deck at the end
            this.payload += '\n---- Bid Deck ----\n';
            const bidObj = JSON.parse(payloadObj.bidDeck);
            this.payload += yaml.dump(bidObj, { quotingType: '"' });
          }
        } else {
          this.payload = '<No payload>';
        }
      }
    });
  };

  private static isBidSubmittedEvent(eventName: string): boolean {
    return eventName == 'texmark_rt_bid.submitted' || eventName == 'texmark_da_bid.submitted';
  }
}
